module.exports = __webpack_public_path__ + "static/media/293651.a9db75f3.png";